export const actions = {
  UPDATE_CONTACT_SERVICES_EDIT_MODE({ commit }: any, payload: boolean) {
    commit('UPDATE_CONTACT_SERVICES_EDIT_MODE_MUTATION', payload)
  }
}
